module.exports = __webpack_public_path__ + "img/rp.e101f3a0.svg";